import React, { useState, useContext } from "react";
import { AppBar, Tabs, Tab, Grid, Paper } from "@material-ui/core";
import { InputTextMaster, TabPanel, useTabStyle } from "App/Component/ui";

import { FormContext } from "../context/FormContext";
import { TabFixedAsset, TabPenyusutan, TabPembayaran } from ".";
import { useWindowDimensions } from "App/hooks";
import { MINUS_WIDTH } from "App/constants";
import { formatNumber } from "App/utils/helpers";
import TabHistory from "./TabHistory/TabHistory";
import TabFile from "./TabFile/TabFile";
import TabKalibrasi from "./TabKalibrasi/TabKalibrasi";
import TabMaintenance from "./TabMaintenance/TabMaintenance";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export default function TabMaster({ changeParentData, menu }) {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);
  const { headData } = useContext(FormContext);
  const { width } = useWindowDimensions();

  // END BARANG

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div
        className={classes.rootTab}
        style={{
          maxWidth: `${width - MINUS_WIDTH}px`,
        }}
      >
        <Paper className={classes.paper}>
          <div
            className="mb-2 mt-1"
            style={{
              padding: "1rem",
            }}
          >
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                  }}
                >
                  <div style={{ flexGrow: 1, maxWidth:'100px'}}>
                    <InputTextMaster
                      name="id"
                      label="ID"
                      id="id"
                      value={headData.id}
                      disabled={true}
                      placeholder="-"
                      style={{
                        padding: "0.7rem 1rem",
                      }}
                    />
                  </div>

                  <div style={{ flexGrow: 1, maxWidth:'100px'}}>
                    <InputTextMaster
                      name="idgl"
                      label="IDGL"
                      id="idgl"
                      value={headData.idgl}
                      disabled={true}
                      placeholder="-"
                      style={{
                        padding: "0.7rem 1rem",
                      }}
                    />
                  </div>

                  <div style={{ flexGrow: 3 }}>
                    <TitleAndPrice
                      title="TOTAL PENYUSUTAN"
                      price={formatNumber(headData.total_penyusutan)}
                    />
                  </div>

                  <div style={{ flexGrow: 3 }}>
                    <TitleAndPrice
                      title="TOTAL CICILAN"
                      price={formatNumber(headData.total_cicilan)}
                    />
                  </div>

                  <div style={{ flexGrow: 3 }}>
                    <TitleAndPrice
                      title="SISA PEMBAYARAN"
                      price={formatNumber(headData.sisa_pemby)}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
        <AppBar
          position="static"
          classes={{
            root: classes.appbar,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            aria-label="Tabs FixedAsset"
            indicatorColor="inherit"
            classes={{
              root: classes.tabs,
              flexContainer: classes.scrollAbel,
            }}
            style={{ display: 'flex'}}
          >
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="FIXED ASSET"
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="PENYUSUTAN"
              {...a11yProps(1)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="HISTORY"
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="HISTORY PEMBAYARAN"
              {...a11yProps(3)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="FILE"
              {...a11yProps(4)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="KALIBRASI"
              {...a11yProps(5)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              sx={{ minWidth: 'fit-content', flex: 1 }}
              label="MAINTENANCE"
              {...a11yProps(6)}
            />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <TabFixedAsset />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
          <TabPembayaran />
        </TabPanel> */}
        <TabPanel value={value} index={1}>
          <TabPenyusutan />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <TabHistory />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <TabPembayaran />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <TabFile />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <TabKalibrasi />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <TabMaintenance />
        </TabPanel>
      </div>
    </div>
  );
}

const TitleAndPrice = ({ title, price }) => {
  return (
    <div
      style={{
        marginTop: "0.4rem",
      }}
    >
      <p
        style={{
          color: "#BDBDBD",
          fontWeight: "500",
          fontSize: "11px",
        }}
      >
        {title}
      </p>
      <p
        style={{
          marginTop: "0.2rem",
          fontSize: "24px",
          fontWeight: "600",
        }}
      >
        Rp. {price}
      </p>
    </div>
  );
};
